export default class Accordion {
  constructor(container, options) {
    this.container = container;
    this.options = {
      item: '.js-accordion-item',
      toggle: '.js-accordion-toggle',
      content: '.js-accordion-content',
      activeClass: 'is-active',
      ...options,
    };
    this.selectedItem = null;
  }

  init() {
    this.getItems(this.container).forEach((item) => {
      const content = item.querySelector(this.options.content);
      content.style.height = 0;
      content.style.display = 'block';
      content.style.overflow = 'hidden';
    });

    window.addEventListener('load', () => {
      this.getItems(this.container).forEach((item) => {
        const toggles = Array.from(item.querySelectorAll(this.options.toggle));

        toggles.forEach((toggle) => {
          toggle.addEventListener('click', (event) => this.handleClick(event, item));

          if (item.classList.contains('is-active')) {
            this.open(item);
          } else {
            this.close(item);
          }
        });
      });
    });

    window.addEventListener('resize', () => {
      this.closeAllItems();
    });
  }

  getItems(container) {
    return Array.from(container.querySelectorAll(this.options.item));
  }

  handleClick(event, item) {
    this.closeAllItems();
    this.toggleItem(event, item, false);
  }

  closeAllItems() {
    this.getItems(this.container).forEach((item) => {
      this.close(item);
    });
  }

  toggleItem(event, item, active) {
    event.preventDefault();

    if (item === this.selectedItem) {
      this.close(item);
      this.selectedItem = null;
      return;
    }

    if (active) {
      this.close(item);
    }

    if (!active) {
      this.open(item);
    }
  }

  close(item) {
    const toggle = item.querySelector(this.options.toggle);
    const content = item.querySelector(this.options.content);
    content.style.height = 0;
    item.classList.remove(this.options.activeClass);
    toggle.classList.remove(this.options.activeClass);
    content.classList.remove(this.options.activeClass);
  }

  open(item) {
    const toggle = item.querySelector(this.options.toggle);
    const content = item.querySelector(this.options.content);
    const contentHeight = content.firstElementChild.scrollHeight;
    content.style.height = `${contentHeight}px`;
    item.classList.add(this.options.activeClass);
    toggle.classList.add(this.options.activeClass);
    content.classList.add(this.options.activeClass);
    this.selectedItem = item;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const accordions = Array.from(document.querySelectorAll('.js-accordion'));
  accordions.forEach((container) => {
    const accordion = new Accordion(container);
    accordion.init();
  });
});
